const home = {
  'home.documentapproval': '文档审批',
  'home.qualitypolicy': '质量方针',
  'home.bylaws': '细则',
  'home.bulletinboard': '公告栏',
  'home.documentdynamics': '文档动态',
  'home.seeall': '查看全部',
};
export default home;
